import {GetProductApiResponse} from "../../../react-query-hooks/products/types";
import {ProductCustomerInsights} from "./customers-section";
import {RevenueSection} from "./revenue-section";

type TSalesAndInsights = {
  productData: GetProductApiResponse;
};

export function SalesAndInsights({productData}: TSalesAndInsights) {
  return (
    <div>
      <RevenueSection
        productId={productData.product.id}
        createdAt={productData.product.createdAt}
      />
      <ProductCustomerInsights
        productId={productData.product.id}
        createdAt={productData.product.createdAt}
      />
    </div>
  );
}
